module.exports = __webpack_public_path__ + "static/media/logo.fd6c96c5.svg";